// Copyright (c) 2026 odavilar
import React from 'react';
import { Box, Typography } from '@mui/material';

export default function SectionHeader({ title, subtitle }) {
  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="h6">{title}</Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>{subtitle}</Typography>
      )}
    </Box>
  );
}
